import React from 'react'
import {
  useTermsAndConditions,
  TermsAndConditionsProps,
} from './useTermsAndConditions'
import styles from './TermsAndConditions.module.scss'
import InnerTitleSection from 'components/InnerTitleSection/InnerTitleSection'

const TermsAndConditions: React.FC<TermsAndConditionsProps> = (
  props: TermsAndConditionsProps
) => {
  const {} = useTermsAndConditions(props)

  return (
    <main id='terms-and-conditions' className={styles['terms-and-conditions']}>
      <InnerTitleSection
        title='Terms and Conditions'
        breadcrumbs={[
          {
            title: 'Home',
            link: '/',
          },
          {
            title: 'Terms and Conditions',
          },
        ]}
      />
      <div className='container py-5'>
        <div className='row'>
          <div className='col-12 mb-4'>
            <h4>Effective Date: 1 July 2025</h4>
            <p>
              Welcome to <b>ByteBuffetBox</b> (“we,” “our,” or “us”). By
              accessing or using our platform, website, or services (the
              “Service”), you agree to comply with and be bound by the following
              Terms and Conditions. If you do not agree, please do not use our
              Service.
            </p>
          </div>
          <div className='col-12 mb-4'>
            <h4>1. Use of the Service</h4>
            <p>
              You may use <b>ByteBuffetBox</b> only for lawful purposes and in
              accordance with these Terms. You agree not to:
            </p>
            <ul>
              <li>
                Use the Service in any way that violates applicable laws or
                regulations.
              </li>
              <li>
                Attempt to gain unauthorized access to any part of the Service.
              </li>
              <li>
                Use the Service to create or distribute unlawful, harmful, or
                misleading content.
              </li>
            </ul>
          </div>
          <div className='col-12 mb-4'>
            <h4>2. Account Registration</h4>
            <p>
              To use certain features, you must create an account. You agree to
              provide accurate, complete, and updated information. You are
              responsible for maintaining the confidentiality of your account
              and password and for all activities that occur under your account.
            </p>
          </div>
          <div className='col-12 mb-4'>
            <h4>3. Subscription and Payments</h4>
            <p>
              We offer both free and paid plans. By subscribing to a paid plan:
            </p>
            <ul>
              <li>
                You agree to pay the stated fees annually or as otherwise
                agreed.
              </li>
              <li>All payments are non-refundable unless stated otherwise.</li>
              <li>
                We reserve the right to change pricing at any time, with notice
                provided in advance.
              </li>
            </ul>
          </div>
          <div className='col-12 mb-4'>
            <h4>4. Cancellation and Termination</h4>
            <p>
              You may cancel your subscription at any time through your account
              dashboard. If you cancel before the end of your billing cycle,
              your access will continue until the end of that period. We reserve
              the right to suspend or terminate your access to the Service if:
            </p>
            <ul>
              <li>You violate these Terms.</li>
              <li>Your payment fails repeatedly.</li>
              <li>We detect abuse or misuse of the platform.</li>
            </ul>
          </div>
          <div className='col-12 mb-4'>
            <h4>5. Intellectual Property</h4>
            <p>
              All content, features, and functionality provided through
              <b> ByteBuffetBox</b> — including software, text, images, and
              branding — are owned by or licensed to us and are protected by
              intellectual property laws. You may not copy, reproduce, or use
              them without our written permission.
            </p>
          </div>
          <div className='col-12 mb-4'>
            <h4>6. User Content</h4>
            <p>
              You retain ownership of any content you upload (menus, images,
              logos, etc.). By submitting content through the Service, you grant
              us a non-exclusive, royalty-free license to host and display that
              content as needed to operate the platform.
            </p>
          </div>
          <div className='col-12 mb-4'>
            <h4>7. Disclaimers</h4>
            <p>
              <b>ByteBuffetBox</b> is provided “as is” and “as available”. We do
              not guarantee uninterrupted service or that the platform will be
              error-free. To the fullest extent permitted by law, we disclaim
              all warranties, express or implied.
            </p>
          </div>
          <div className='col-12 mb-4'>
            <h4>8. Limitation of Liability</h4>
            <p>
              To the maximum extent permitted by law, <b>ByteBuffetBox</b> shall
              not be liable for any indirect, incidental, or consequential
              damages arising out of or in connection with your use of the
              Service.
            </p>
          </div>
          <div className='col-12 mb-4'>
            <h4>9. Modifications</h4>
            <p>
              We may revise these Terms from time to time. Any changes will be
              posted on this page, and your continued use of the Service after
              changes take effect constitutes acceptance.
            </p>
          </div>
          <div className='col-12 mb-4'>
            <h4>10. Content Responsibility and Compliance</h4>
            <p>
              As the management of the website, we only provide a technical
              service (SaaS) and are not responsible for the content or products
              presented by restaurants or users. Furthermore, we do not endorse
              or encourage any product or service that violates Islamic law
              (Sharia) or local regulations.
            </p>
          </div>
          <div className='col-12 mb-4'>
            <h4>11. Contact Us</h4>
            <p>
              If you have any questions about these Terms, please contact us at:
              <br />
              <i className='bi bi-envelope-open me-1'></i>{' '}
              <a href='mailto:support@bytebuffetbox.com'>
                support@bytebuffetbox.com
              </a>{' '}
              <br />
              <i className='bi bi-telephone-fill me-1'></i>{' '}
              <a href='tel:+96176851367'>+961 76 951 367</a>
            </p>
          </div>
        </div>
      </div>
    </main>
  )
}

export default TermsAndConditions
